var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUrgent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1785_10275)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1785_10275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 12.6663C10.5772 12.6663 12.6666 10.577 12.6666 7.99967C12.6666 5.42235 10.5772 3.33301 7.99992 3.33301C5.42259 3.33301 3.33325 5.42235 3.33325 7.99967C3.33325 10.577 5.42259 12.6663 7.99992 12.6663Z",
    stroke: "#E81A33",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6V8L9 9",
    stroke: "#E81A33",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0066 11.567L10.7732 14.1203C10.7432 14.4528 10.5896 14.7618 10.3427 14.9865C10.0958 15.2111 9.77369 15.335 9.43991 15.3337H6.55324C6.21946 15.335 5.89731 15.2111 5.65044 14.9865C5.40357 14.7618 5.24994 14.4528 5.21991 14.1203L4.98657 11.567M4.99324 4.43367L5.22657 1.88034C5.25651 1.54905 5.40919 1.24093 5.65465 1.01644C5.90011 0.79195 6.22061 0.667316 6.55324 0.667003H9.45324C9.78702 0.665649 10.1092 0.789535 10.356 1.01419C10.6029 1.23884 10.7565 1.54791 10.7866 1.88034L11.0199 4.43367",
    stroke: "#E81A33",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1785_10275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1785_10275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrgent);
export default __webpack_public_path__ + "static/media/urgent.45133c48ab40bdf0d150e90cf2e87ab3.svg";
export { ForwardRef as ReactComponent };